import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// 解决路由重复点击报异常问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import(/* webpackChunkName: "home" */ "../views/login.vue"),
    meta: {
      keepAlive: false, // 不需要缓存
    },
  },
  {
    path: "/userLoginout",
    name: "user_loging_out",
    component: () => import("@views/userLoginout.vue"),
    meta: {
      title: "宣传册",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "home" */ "../views/login.vue"),
    meta: {
      keepAlive: false, // 不需要缓存
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import(/* webpackChunkName: "home" */ "../views/ResetPassword.vue"),
    meta: {
      keepAlive: false, // 不需要缓存
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "home" */ "../layouts/Home.vue"),
    meta: {
      keepAlive: false, // 不需要缓存
    },
    children: [
      {
        path: "/",
        name: "welcome",
        component: () => import(/* webpackChunkName: "home" */ "../views/welcome.vue"),
        meta: {
          title: "欢迎页",
        },
      },
      {
        path: "/user_list",
        name: "user_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/user/list.vue"),
        meta: {
          title: "用户列表",
        },
      },
      {
        path: "/user_detail",
        name: "user_detail",
        component: () => import(/* webpackChunkName: "user" */ "@views/user/detail.vue"),
        meta: {
          requireAuth: true,
          title: "用户详情",
        },
      },
      {
        path: "/effect_list",
        name: "effect_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/effect/effect_list.vue"),
        meta: {
          title: "效果库列表",
        },
      },
      {
        path: "/effect_audit",
        name: "effect_audit",
        component: () => import(/* webpackChunkName: "user" */ "@views/effect/effect_audit.vue"),
        meta: {
          title: "效果库审核",
        },
      },
      {
        path: "/equipment_list",
        name: "equipment_list",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/equipment/equipment/list.vue"),
        meta: {
          title: "设备列表",
        },
      },
      // {
      //   path: "/ncc_equipment_list",
      //   name: "ncc_equipment_list",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "user" */ "@views/equipment/equipment/ncc_list.vue"
      //     ),
      //   meta: {
      //     title: "ncc设备说明管理"
      //   }
      // },
      {
        path: "/equipment_import",
        name: "equipment_import",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/equipment/import/import.vue"),
        meta: {
          title: "导入设备",
        },
      },
      {
        path: "/FirmwareVersion_list",
        name: "FirmwareVersion_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/FirmwareVersion"),
        meta: {
          title: "固件版本管理",
        },
      },
      {
        path: "/FirmwareVersion_list_Plant",
        name: "FirmwareVersion_list_Plant",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/FirmwareVersion/PlantFirmwareVersion.vue"),
        meta: {
          title: "固件版本管理",
        },
      },
      {
        path: "/statistic_user",
        name: "statistic_User",
        component: () => import(/* webpackChunkName: "user" */ "@views/statistic/user"),
        meta: {
          title: "用户统计",
        },
      },
      {
        path: "/statistic_equipment",
        name: "statistic_equipment",
        component: () => import(/* webpackChunkName: "user" */ "@views/statistic/equipment"),
        meta: {
          title: "设备统计",
        },
      },
      {
        path: "/statistic_auxiliaryMeans",
        name: "statistic_auxiliaryMeans",
        component: () => import(/* webpackChunkName: "user" */ "@views/statistic/auxiliaryMeans"),
        meta: {
          title: "辅助工具统计",
        },
      },
      {
        path: "/DeviceTypeManagement",
        name: "DeviceTypeManagement",
        component: () => import(/* webpackChunkName: "user" */ "@views/DeviceTypeManagement/"),
        meta: {
          title: "设备类型管理",
        },
      },
      {
        path: "/feedback_list",
        name: "feedback_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/Other/feedback/list.vue"),
        meta: {
          title: "意见反馈",
        },
      },
      {
        path: "/app_feedback_list",
        name: "app_feedback_list",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/Other/feedback/app_list.vue"),
        meta: {
          title: "应用版意见反馈",
        },
      },
      {
        path: "/EquipmentTips",
        name: "equipment_tips",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/Other/equipmentTips/index.vue"),
        meta: {
          title: "设备提示",
        },
      },
      {
        path: "/profess_list",
        name: "profess_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/Other/profess/list.vue"),
        meta: {
          title: "职业管理",
        },
      },
      {
        path: "/official_list",
        name: "official_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/Other/official/list.vue"),
        meta: {
          title: "官方教程",
        },
      },
      {
        path: "/official_details",
        name: "official_details",
        component: () => import(/* webpackChunkName: "user" */ "@views/Other/official/details.vue"),
        meta: {
          title: "教程详情",
        },
      },
      {
        path: "/administrator_list",
        name: "administrator_list",
        component: () =>
          import(/* webpackChunkName: "user" */ "@views/system/administrator/list.vue"),
        meta: {
          title: "系统管理员",
        },
      },
      {
        path: "/log_list",
        name: "log_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/system/log/list.vue"),
        meta: {
          title: "操作日志",
        },
      },
      {
        path: "/systemUpdate",
        name: "systemUpdate",
        component: () => import(/* webpackChunkName: "user" */ "@views/systemUpdate/"),
        meta: {
          title: "APP更新",
        },
      },
      {
        path: "/role_list",
        name: "role_list",
        component: () => import(/* webpackChunkName: "user" */ "@views/system/role/list.vue"),
        meta: {
          title: "角色管理",
        },
      },
      {
        path: "/firmware",
        name: "firmware",
        component: () => import("@views/neewerdownload/firmware.vue"),
        meta: {
          title: "固件管理",
        },
      },
      {
        path: "/neewerai",
        name: "neewerai",
        component: () => import("@views/neewerdownload/neewerai.vue"),
        meta: {
          title: "AI 版本管理",
        },
      },
      {
        path: "/instruction",
        name: "instruction",
        component: () => import("@views/neewerdownload/instruction.vue"),
        meta: {
          title: "说明书管理",
        },
      },
      {
        path: "/faq",
        name: "faq",
        component: () => import("@views/neewerdownload/faq.vue"),
        meta: {
          title: "FAQ管理",
        },
      },
      {
        path: "/brochure",
        name: "brochure",
        component: () => import("@views/neewerdownload/brochure.vue"),
        meta: {
          title: "宣传册管理",
        },
      },
      {
        path: "/app_version",
        name: "app_version",
        component: () => import("@views/neewerdownload/app_version.vue"),
        meta: {
          title: "软件版本管理",
        },
      },
      {
        path: "/ncc",
        name: "ncc",
        component: () => import("@views/ncc/ncc_list.vue"),
        meta: {
          title: "宣传册",
        },
      },
      {
        path: "/app_pc_list",
        name: "app_pc_list",
        component: () => import("@views/systemUpdate/index.vue"),
        meta: {
          title: "宣传册",
        },
      },
      {
        path: "/deviceAuth",
        name: "deviceAuth",
        component: () => import("@views/neewerhome/deviceAuth.vue"),
        meta: {
          title: "设备注册",
        },
      },
      {
        path: "/mqtt_log",
        name: "mqtt_log",
        component: () => import("@views/neewerhome/mqttInfo.vue"),
        meta: {
          title: "指令日志",
        },
      },
      {
        path: "/timeColorVersion",
        name: "timeColorVersion",
        component: () => import("@views/neewerhome/timeColorVersion.vue"),
        meta: {
          title: "定时颜色固件版本",
        },
      },
      {
        path: "/effectEightLang",
        name: "effectEightLang",
        component: () => import("@views/neewerhome/effectEightLang.vue"),
        meta: {
          title: "场景特效八国语言翻译",
        },
      },
      {
        path: "/diyEffectType",
        name: "diyEffectType",
        component: () => import("@views/neewerhome/diyEffectType.vue"),
        meta: {
          title: "DIY场景类别",
        },
      },
      {
        path: "/diyEffectName",
        name: "diyEffectName",
        component: () => import("@views/neewerhome/diyEffectName.vue"),
        meta: {
          title: "DIY场景名称",
        },
      },
      {
        path: "/diySceneEffect",
        name: "diySceneEffect",
        component: () => import("@views/neewerhome/diySceneEffect.vue"),
        meta: {
          title: "DIY场景特效",
        },
      },
      {
        path: "/audio_device_config",
        name: "audio_device_config",
        component: () => import("@views/neewerview/deviceConfig.vue"),
        meta: {
          title: "麦克风设备号管理",
        },
      },
      {
        path: "/ncc_version",
        name: "ncc_version",
        component: () => import("@views/ncc/ncc_version.vue"),
        meta: {
          title: "版本管理",
        },
      },
      {
        path: "/sceneEffect",
        name: "sceneEffect",
        component: () => import("@views/neewerhome/sceneEffect.vue"),
        meta: {
          title: "场景特效",
        },
      },
      {
        path: "/diySetting",
        name: "diySetting",
        component: () => import("@views/neewerhome/diySetting.vue"),
        meta: {
          title: "DIY设置",
        },
      },
      {
        path: "/matter-admin",
        name: "matterAdmin",
        component: () => import("@views/matterAdmin/qrcode.vue"),
        meta: {
          title: "matter 二维码平台",
        },
      },
    ],
  },
];

const router = new Router({
  routes: routes,
});

router.beforeEach((to, from, next) => {
  let accessToken = localStorage.getItem("accessToken");
  if (!accessToken && to.path != "/" && to.path != "/login" && to.path != "/reset-password") {
    next("/");
  } else {
    next();
  }
});

export default router;
